import React from 'react';
import { Button } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { useDownloadProceduresMutation } from '../../../../services/ConfigurationService';

interface ProcedureDownloadCsvProps {
  company: string;
  centerId: string;
  disabled?: boolean;
  onError?: (error: string) => void;
}

const ProcedureDownloadCsv: React.FC<ProcedureDownloadCsvProps> = ({ 
  company, 
  centerId, 
  disabled = false,
  onError 
}) => {
  const [downloadProcedures, { isLoading: isDownloading }] = useDownloadProceduresMutation();

  const handleDownload = async () => {
    if (!company || !centerId) {
      console.warn('Company and Center ID are required');
      return;
    }
    
    try {
      const blob = await downloadProcedures({
        company,
        centerId
      }).unwrap();
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Procedures_${company}_${centerId}_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      console.error('Download failed:', err);
      onError?.(err?.data?.message || err?.message || 'Download failed');
    }
  };

  const isDisabled = disabled || !company || !centerId || isDownloading;

  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={handleDownload}
      size="small"
      disabled={isDisabled}
    >
      Download CSV
    </Button>
  );
};

export default ProcedureDownloadCsv;